import { TextField, inputBaseClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledTextField = styled(TextField)(({ theme }) => ({
  [`.${inputBaseClasses.root}`]: {
    margin: "12px 0",
    padding: "8px",
    minWidth: "240px",
    height: "120px",
    boxSizing: "border-box",
    background: theme.palette.grey[50],
    "&:hover": {
      background: theme.palette.grey[50]
    }
  },
  [`.${inputBaseClasses.input}`]: {
    margin: "12px 0",
    minWidth: "240px",
    height: "120px",
    boxSizing: "border-box"
  }
}));
const ButtonsWrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-end"
}));
export {
  ButtonsWrapper,
  StyledTextField
};
